import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const MiniCardLayout = props => (
    <div
        className={classNames('mini-card', props.className, {
            'block-screen': props.isScreenBlocked,
            'disabled-measure': props.isGreyedOut,
        })}>
        {props.children}
    </div>
);

MiniCardLayout.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    isScreenBlocked: PropTypes.bool,
    isGreyedOut: PropTypes.bool,
};

MiniCardLayout.defaultProps = {
    className: '',
    children: undefined,
    isScreenBlocked: false,
    isGreyedOut: false,
};

export default MiniCardLayout;
